import { defineStore } from "pinia";

import { Unit } from "frontend/interfaces/unit";
import { Attendance } from "frontend/interfaces/settings/attendance";

interface ClipboardStoreState {
  unit: Unit | null;
  attendance: Attendance | null;
  ctxAction: string | null;
}

export const id = "clipboard";

export const useStore = defineStore(id, {
  state(): ClipboardStoreState {
    return {
      unit: null,
      attendance: null,
      ctxAction: null,
    };
  },
  actions: {
    getUnit() {
      return this.unit;
    },
    setUnit(data: Unit) {
      this.unit = data;
    },
    clearUnit() {
      this.unit = null;
    },
    getAttendance() {
      return this.attendance;
    },
    setAttendance(data: Attendance) {
      this.attendance = data;
    },
    clearAttendance() {
      this.attendance = null;
    },
    getCtxAction() {
      return this.ctxAction;
    },
    setCtxAction(data: string) {
      this.ctxAction = data;
    },
    clearCtxAction() {
      this.ctxAction = null;
    },
  },
});
